/*
export function someMutation (state) {
}
*/
export function UpdateSetting(state, setting) { 
  state.year = setting.year 
  state.semester = setting.semester
  state.lock_ = setting.lock
}
